var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("stand-pagination-table", {
        attrs: {
          columns: _vm.mainTable.columns,
          data: _vm.mainTable.data,
          loading: _vm.mainTable.loading,
          "table-search": _vm.mainTable.tableSearch,
          "table-load-event": _vm.getAboutTableRecords,
        },
      }),
      _c(
        "Modal",
        {
          attrs: { title: "关于我们", width: "800px" },
          model: {
            value: _vm.aboutUsFromShow,
            callback: function ($$v) {
              _vm.aboutUsFromShow = $$v
            },
            expression: "aboutUsFromShow",
          },
        },
        [
          _c(
            "Form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "标题" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.aboutUsFrom.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.aboutUsFrom, "title", $$v)
                              },
                              expression: "aboutUsFrom.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "内容" } },
                        [
                          _c("quill-editor", {
                            model: {
                              value: _vm.aboutUsFrom.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.aboutUsFrom, "content", $$v)
                              },
                              expression: "aboutUsFrom.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  staticClass: "form-button",
                  attrs: { type: "success" },
                  on: { click: _vm.onAboutSave },
                },
                [_vm._v("保存")]
              ),
              _c(
                "Button",
                {
                  staticClass: "form-button",
                  attrs: { type: "text" },
                  on: { click: _vm.onAboutCancel },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-tool-bar" }, [
      _c("div", { staticClass: "left-bar" }, [
        _c("span", { staticClass: "title" }, [_vm._v("关于我们列表")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }